<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <div class="inner">
      <add-button v-if="$_createActionAllowed" :title="'Přidat profil zařízení' | translate" route-name="deviceProfileNew"></add-button>
      <h1 v-translate>Profily zařízení</h1>
    </div>
    <div class="inner_white">
      <div class="filter">
        <div class="field_left">
          <search-input input-class="search" v-model="formFields.search"></search-input>
        </div>
        <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset"
           :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
      </div>

      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="device-profiles-list">
          <table class="vypis vypis_detail">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"></th>
              <sorting-table-title
                  v-for="title in sortingTableTitles"
                  :key="title.key"
                  :column="title.column"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"></th>
            </tr>
            </thead>

            <device-profile-row
                v-for="deviceProfile in entities"
                :entity="deviceProfile"
                :selectedEntities="selectedEntities"
                @input="select"
                :key="deviceProfile.id"
                @deleteDeviceProfile="deleteEntity"
                :ref="'device-type-row-ref-'+deviceProfile.id"
            ></device-profile-row>
<tr v-if="entities.length === 0">
     <td colspan="8">{{ $gettext('Nebyly nalezeny žádné profily zařízení.') }}</td>
</tr>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="filteredSelectedEntities"
          :multiple-action-options="multipleActionOptions"
          table-id="device-profiles-list"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          @limit="setLimit"
          @offset="setOffset"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import DeviceProfileRow from "@/components/views/deviceProfiles/DeviceProfileRow"
import listActions from "@/components/mixins/list-actions"

export default {
  name: "DeviceProfiles",
  components: {
    DeviceProfileRow,
  },
  mixins: [listActions],
  data() {
    return {
      moduleName: 'deviceProfiles',
      formFields: {
        sort: {
          column: 'sName',
          direction: 'asc',
        }
      }
    }
  },
  created(DeviceProfileService) {
    this.entityService = DeviceProfileService
    this.createdInit()
  },
  computed: {
    deviceProfilesTableTitlesOwner() {
      return [
        {key: 1, name: this.$gettext('Název'), column: 'sName'},
        {key: 2, name: this.$gettext('Operátor'), column: 'sNameOperator'},
        {key: 3, name: this.$gettext('Typy zařízení'), column: 'sDeviceTypes', sortable: false},
        {key: 5, name: this.$gettext('Počet zařízení'), column: 'sDeviceCount'},
        {key: 6, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
        {key: 7, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
      ]
    },
    deviceProfilesTableTitlesOperator() {
      return [
          {key: 1, name: this.$gettext('Název'), column: 'sName'},
          {key: 3, name: this.$gettext('Typy zařízení'), column: 'sDeviceTypes', sortable: false},
          {key: 5, name: this.$gettext('Počet zařízení'), column: 'sDeviceCount'},
          {key: 6, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
          {key: 7, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
      ]
    },
    sortingTableTitles() {
      if (this.$_readActionAllowedAllOrOwnAndGlobal) {
          return this.deviceProfilesTableTitlesOwner
      } else {
          return this.deviceProfilesTableTitlesOperator
      }
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles)
      headers.device_types.callback = entity => {return entity.device_types.length;};

      return headers;
    },
  },
  methods: {
    _processListErrorMessage(error) {
      let errorMessage = null;

      this._.forEach(error['validation_errors'], function (message) {
          errorMessage = message;
      }.bind(this))

      return errorMessage || error['error_message'];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceProfiles/DeviceProfilesList.vue